var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('section',[_c('div',{staticClass:"row pb-5"},[_c('div',{staticClass:"col"},[_vm._v("\n            "+_vm._s(_vm.$t('auth.closed-shop-info'))+"\n        ")])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }